import React from 'react';
import { FaShieldAlt, FaCheckCircle, FaFacebook, FaTwitter, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import '../style.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Left Section - Logo & Company Info */}
       <div className="logo">
  <img 
    src="/logo.png"
    alt="VNS Tour And Travels Logo"
    className="footer-logo-img"
  />
  <div className="logo-text">
    <h2>VNS Tour And Travels</h2>
    <p className="logo-tagline">Your Trusted Travel Partner</p>
    <p className="company-description"> Enjoy smooth and stress-free travel in Varanasi with our reliable cab services, personalized sightseeing tours, and experienced chauffeurs committed to your comfort and safety.</p>
    <h1 className="footer-trust">
      Trusted by local travelers and tourists for safe, punctual, and comfortable journeys across Varanasi.
    </h1>

    <ul className="footer-highlights">
      <li>✔ 24×7 Cab Availability</li>
      <li>✔ Clean & Comfortable Vehicles</li>
      <li>✔ Experienced Local Drivers</li>
    </ul>
  </div>
</div>


        {/* Middle Section - Navigation */}
        <div className="footer-middle">
          <div className="footer-column">
            <h3 className="column-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/sightseeing">Sightseeing</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/airport-transfer">Airport Transfer</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="column-title">Our Services</h3>
            <ul className="footer-links">
              <li><a href="/book-cab">Book Cab</a></li>
              <li><a href="/packages">Tour Packages</a></li>
              <li><a href="/outstation">Outstation</a></li>
              <li><a href="/payment">Payment</a></li>
              <li><a href="/contact-us">Contact Us</a></li>
            </ul>
          </div>
        </div>

        {/* Right Section - Contact Info (Exact same style as Our Services) */}
<div className="footer-right">
  <div className="footer-column">
    <h3 className="column-title">Reach Us</h3>
    <ul className="footer-links">
      <li>
        <span className="contact-label">Email: </span>
        <a href="mailto:cabservicevaranasi44@gmail.com">
          vnstoursandtravels9696@gmail.com
        </a>
      </li>
      
      <li>
        <span className="contact-label">Phone: </span>
        <a href="tel:+917406654900">6307291567</a>
      </li>
      <li>
        <span className="contact-label">Location: </span>
       G.T road Mohansarai bypas Rajatalab Varanasi UP-221302
      </li>
    </ul>
  </div>
</div>
      </div>

      {/* Bottom Footer - Copyright */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="copyright">
            &copy; {currentYear} VNS Tour And Travels. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-conditions">Terms & Conditions</a>
            <a href="/refund-policy">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;